// removed by extract-text-webpack-plugin
module.exports = {"radio":"radio--radio--jA56WMNS","radioOverlay":"radio--radioOverlay--1SBT8t8I","label":"radio--label--2kymLMgk"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/Radio/radio.scss
// module id = 656
// module chunks = 0